import { AppEnv } from '../appEnv';
import { assertNever } from '../assertNever';

export type DefaultProfileImageUrl =
  | 'https://cdn-stg-nurse-senka-user-profile-pictures.smsc-nsc.com/default/unknown.jpg'
  | 'https://cdn-nurse-senka-user-profile-pictures.nurse-senka.jp/default/unknown.jpg';

export const defaultProfileImageUrl = (
  appEnv: AppEnv,
): DefaultProfileImageUrl => {
  switch (appEnv) {
    case 'local':
    case 'qa':
    case 'staging':
      return 'https://cdn-stg-nurse-senka-user-profile-pictures.smsc-nsc.com/default/unknown.jpg';
    case 'production':
      return 'https://cdn-nurse-senka-user-profile-pictures.nurse-senka.jp/default/unknown.jpg';
    default:
      return assertNever(appEnv);
  }
};
